/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventStarterPackInfoDepositRequest model module.
 * @module model/EventsControllerDtoEventStarterPackInfoDepositRequest
 * @version 1.0
 */
class EventsControllerDtoEventStarterPackInfoDepositRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventStarterPackInfoDepositRequest</code>.
     * @alias module:model/EventsControllerDtoEventStarterPackInfoDepositRequest
     * @param packNo {Number} 
     * @param transactionHash {String} 
     */
    constructor(packNo, transactionHash) { 
        
        EventsControllerDtoEventStarterPackInfoDepositRequest.initialize(this, packNo, transactionHash);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, packNo, transactionHash) { 
        obj['packNo'] = packNo;
        obj['transactionHash'] = transactionHash;
    }

    /**
     * Constructs a <code>EventsControllerDtoEventStarterPackInfoDepositRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventStarterPackInfoDepositRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventStarterPackInfoDepositRequest} The populated <code>EventsControllerDtoEventStarterPackInfoDepositRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventStarterPackInfoDepositRequest();

            if (data.hasOwnProperty('packNo')) {
                obj['packNo'] = ApiClient.convertToType(data['packNo'], 'Number');
            }
            if (data.hasOwnProperty('transactionHash')) {
                obj['transactionHash'] = ApiClient.convertToType(data['transactionHash'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventStarterPackInfoDepositRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventStarterPackInfoDepositRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of EventsControllerDtoEventStarterPackInfoDepositRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['transactionHash'] && !(typeof data['transactionHash'] === 'string' || data['transactionHash'] instanceof String)) {
            throw new Error("Expected the field `transactionHash` to be a primitive type in the JSON string but got " + data['transactionHash']);
        }

        return true;
    }


}

EventsControllerDtoEventStarterPackInfoDepositRequest.RequiredProperties = ["packNo", "transactionHash"];

/**
 * @member {Number} packNo
 */
EventsControllerDtoEventStarterPackInfoDepositRequest.prototype['packNo'] = undefined;

/**
 * @member {String} transactionHash
 */
EventsControllerDtoEventStarterPackInfoDepositRequest.prototype['transactionHash'] = undefined;






export default EventsControllerDtoEventStarterPackInfoDepositRequest;

